<div class="main-content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-header card/-header-primary card-header-icon">
        <div class="card-icon">
          <i class="material-icons">group</i>
        </div>
        <h4 class="card-title">Customers</h4>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md-12" style="text-align: right">
            <div style="float: right; margin-right: 20px" class="row">
              <button
                (click)="openNuevoPaciente()"
                mat-raised-button
                class="btn btn-success"
              >
                <span class="btn-label">
                  <i class="material-icons">person_add</i>
                </span>
                New Customer
              </button>

              &nbsp;&nbsp;

              <button
                mat-raised-button
                class="btn btn-primary"
                [routerLink]="['/categories']"
              >
                <span class="btn-label"> </span>
                Categories
              </button>

              &nbsp;&nbsp;

              <button
                type="button"
                class="btn btn-outline-{{ activos === 1 ? 'info' : 'danger' }}"
                (click)="cambiarActivos()"
              >
                <i class="fa fa-eye" aria-hidden="true"></i> Show
                {{ activos === 1 ? "Inactive" : "Active" }} Customers
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2">
            <h4><b>Filters:</b></h4>

            <div class="row">
              <div class="col-7">
                <button
                  class="btn btn-warning btn-sm"
                  (click)="getCustomers()"
                  [disabled]="cargando"
                >
                  <i
                    *ngIf="!cargando"
                    class="fa fa-search"
                    aria-hidden="true"
                  ></i>
                  <i
                    *ngIf="cargando"
                    class="fa fa-spinner fa-pulse"
                    aria-hidden="true"
                  ></i>
                  Search
                </button>
              </div>
              <div class="col-1">
                <button
                  class="btn btn-default btn-sm"
                  (click)="userCategories = []"
                >
                  <i class="fa fa-undo" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <br />
            <div class="row" *ngFor="let item of categories">
              <div class="col-12">
                <div class="row">
                  <mat-checkbox
                    [name]="item.name"
                    (change)="addCategoire(item, $event)"
                    [checked]="isCheked(item)"
                    >{{ item.name }}</mat-checkbox
                  >
                </div>
                <div *ngIf="isAdded(item.id)">
                  <div class="row" *ngIf="item.sub.length > 1">
                    &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                    <mat-checkbox
                      [name]="item.id"
                      (change)="
                        addCategoire(
                          { id: item.id, father: item.id, name: 'All' },
                          $event
                        )
                      "
                      [checked]="checkedAll(item.id)"
                      >All</mat-checkbox
                    >
                  </div>
                  <div class="row" *ngFor="let i of item.sub">
                    &nbsp;&nbsp;&nbsp; <b>-&nbsp; </b>
                    <mat-checkbox
                      [name]="i.name"
                      (change)="addCategoire(i, $event)"
                      [checked]="isCheked(i)"
                      >{{ i.name }}</mat-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-10">
            <app-loading *ngIf="cargando"></app-loading>
            <app-customers-table
              *ngIf="!cargando"
              [elements]="customers"
              [options]="options"
              (newOptions)="updateConfig($event)"
              (out)="boton($event)"
            >
            </app-customers-table>
            <div
              class="modal fade"
              id="modalNotes"
              tabindex="-1"
              role="dialog"
              data-keyboard="false"
            >
              <div
                class="modal-dialog modal-dialog-scrollable modal-md"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h3>Notes about this client:</h3>
                    <button class="close" (click)="close()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>

                  <div class="modal-body">
                    <div class="row">
                      <div class="container">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="panel panel-primary">
                              <div class="panel-heading" id="accordion"></div>
                              <div class="">
                                <app-comments
                                  [id_phather]="idUser"
                                  type_chat="CUSTOMER"
                                  type_notification="CITA_COMMENT"
                                ></app-comments>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="tagModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="text-align: center">
        <h2><b>Tags</b></h2>
        <br />
      </div>

      <div class="modal-body">
        <app-loading *ngIf="gettingUsersTags"></app-loading>
        <mat-progress-bar
          style="width: 80%; margin-bottom: 10px"
          *ngIf="loadingbar"
          id="loadingbar"
          mode="indeterminate"
        ></mat-progress-bar>

        <div *ngIf="!gettingUsersTags" class="row">
          <div class="col-6" *ngFor="let tag of tags">
            <mat-checkbox
              (change)="addTag($event, tag.id)"
              [checked]="checkTag(tag.id)"
              [name]="tag.name"
              >{{ tag.name }}</mat-checkbox
            >
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger btn-lg btn-block"
          (click)="closeTagModal()"
        >
          Close
        </button>
        &nbsp;&nbsp;
      </div>
    </div>
  </div>
</div>
